export const form = {
  email: {
    label: 'Correo electrónico',
    placeholder: 'Introduce la dirección de correo'
  },
  name: {
    label: 'Nombre',
    placeholder: 'Introduce el nombre'
  },
  clubName: {
    label: 'Nombre del club',
    placeholder: 'Introduce el nombre del club',
    description: 'Escribe el nombre en caracteres latinos'
  },
  address: {
    label: 'Dirección',
    placeholder: 'Introduce la dirección'
  },
  workPeriod: {
    start: {
      placeholder: 'Inicio del trabajo'
    },
    end: {
      placeholder: 'Fin del trabajo'
    }
  },
  workTime: {
    start: {
      label: 'Hora de apertura'
    },
    end: {
      label: 'Hora de cierre'
    }
  },
  country: {
    label: 'Ubicación del club',
    placeholder: 'Indica la ubicación del club'
  },
  role: {
    label: 'Vacantes en el club'
  },
  currency: {
    label: 'Moneda de los pagos a los artistas',
    placeholder: 'Indica la moneda de los pagos a los artistas'
  },
  nativeLanguage: {
    label: 'Lengua materna',
    placeholder: 'Indica tu idioma nativo'
  },
  lastName: {
    label: 'Apellido',
    placeholder: 'Introduce tu apellido'
  },
  birth: {
    label: 'Fecha de nacimiento',
    placeholder: 'Introduce la fecha de nacimiento'
  },
  password: {
    label: 'Contraseña',
    placeholder: 'Introduce la contraseña',
    description:
      'La contraseña debe contener al menos 8 caracteres, con mayúsculas y minúsculas, números y caracteres especiales (p. ej., !, @, #, $).'
  },
  resetPassword: {
    new: {
      label: 'Nueva contraseña',
      placeholder: 'Introduce una nueva contraseña'
    },
    confirm: {
      label: 'Confirmar contraseña',
      placeholder: 'Repite la nueva contraseña'
    }
  },
  penalties: {
    placeholder: 'Introduce el nombre de la multa'
  },
  phone: {
    label: 'Número de teléfono',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Continuar',
    login: 'Iniciar sesión',
    send: 'Enviar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    resend: 'Reenviar',
    register: 'Registrarse',
    registerRequest: 'Enviar solicitud de registro'
  },
  links: {
    forgotPasswordLink: '¿Olvidaste tu contraseña?',
    login: 'Ingresar',
    haveAccount: 'Ya tengo una cuenta',
    privacy: 'Acuerdo de usuario y Política de privacidad'
  },
  other: {
    or: 'O'
  },
  approximateStartDate: {
    label: 'Fecha de inicio aproximada'
  },
  approximateEndDate: {
    label: 'Fecha de finalización aproximada'
  },
  search: {
    placeholder: 'Buscar',
    placeholderCitizienship: 'Buscar ciudadanía'
  },
  positionItem: {
    label: 'Introduce el puesto'
  },
  paymentFrequency: {
    label: 'Frecuencia de pagos'
  },
  price: {
    label: 'Precio'
  },
  priceForArtist: {
    label: 'Monto para el artista'
  },
  artistPercent: {
    label: 'Porcentaje del artista'
  }
};
